export const authHeader = {
    'Authorization': 'Basic a2FtaW5vOjdkNG89NDJsRy13Pw=='
}

export const authHeaderMultipart = {
    'Content-Type': 'multipart/form-data',
    'Authorization': 'Basic a2FtaW5vOjdkNG89NDJsRy13Pw=='
}